import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';

const SmsConsentPreview = () => {
  const [checked, setChecked] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  return (
    <Box
      sx={{
        maxWidth: 420,
        width: '100%',
        m: '2rem auto',
        p: 3,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant='h6' fontWeight={700} sx={{ mb: 2 }}>
        SMS updates
      </Typography>

      <TextField
        id='phone'
        name='phone'
        label='Phone number'
        type='tel'
        placeholder='+1 (916) 555-0134'
        fullWidth
        size='small'
        sx={{ mb: 2 }}
      />

      <FormControlLabel
        sx={{ alignItems: 'flex-start', gap: 1, ml: 0 }}
        control={
          <Checkbox
            id='sms-consent-checkbox'
            name='sms_consent'
            value='true'
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            sx={{ pt: 0 }}
          />
        }
        label={
          <Typography variant='body2' sx={{ lineHeight: 1.4 }}>
            I agree to receive SMS order and delivery updates from Meeth at the
            phone number provided. Message frequency varies. Message and data
            rates may apply. Reply STOP to unsubscribe, HELP for help. View our{' '}
            <a href='https://soopra.ai/meeth/terms#privacy' target='_blank' rel='noopener noreferrer'>
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href='https://soopra.ai/meeth/terms#terms' target='_blank' rel='noopener noreferrer'>
              Terms &amp; Conditions
            </a>
            .
          </Typography>
        }
      />

      <Button
        type='button'
        variant='contained'
        fullWidth
        sx={{ mt: 2, height: 40 }}
        onClick={() => setSubmitted(true)}
      >
        Submit
      </Button>

      {submitted && (
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1.5 }}>
          Thanks — this preview does not send live messages.
        </Typography>
      )}
    </Box>
  );
};

export default SmsConsentPreview;
